export default __webpack_public_path__ + "static/media/Navidalia_Logo.ad176995.png";